export enum DataSpaKey {
  banner = 'banner',
  bundle = 'bundle',
  contentCategory = 'contentCategory',
  couponCode = 'couponCode',
  mobileCouponCode = 'mobileCouponCode',
  nbnCouponCode = 'nbnCouponCode',
  crossSell = 'crossSell',
  enableLoginCta = 'enableLoginCta',
  focusSku = 'focusSku',
  host = 'host',
  isGuidedFlow = 'isGuidedFlow',
  mode = 'mode',
  offerId = 'offerId',
  productcategory = 'productcategory',
  addressBarTitle = 'addressBarTitle',
  addressBarPlaceholder = 'addressBarPlaceholder',
  addressBarAlignment = 'addressBarAlignment',
  aemCIFIntegration = 'aemCIFIntegration',
  nbnMoversCrossSell = 'nbnMoversCrossSell',
  isMobile = 'isMobile',
  isNbnMovers = 'isNbnMovers',
  isInternetPlansPage = 'isInternetPlansPage',
  isCampaignPage = 'isCampaignPage'
}
